module.exports = __WEBPACK_EXTERNAL_MODULE_73__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/dashboard-common/dist/ui/AuthoringToolbar"
// module id = 73
// module chunks = 1